export const supplyChainServices = [
  {
    name: "Product Sourcing",
    path: "/services/sourcing/",
    stage: "Source",
    description: "Find manufacturers that fit the product, volume, and commercial requirements.",
  },
  {
    name: "Supplier Verification",
    path: "/services/supplier-verification/",
    stage: "Verify",
    description: "Check the supplier, stated capabilities, and production fit before committing.",
  },
  {
    name: "Sampling & Product Development",
    path: "/services/product-development/",
    stage: "Develop",
    description: "Coordinate samples, revisions, specifications, and approval before mass production.",
  },
  {
    name: "Procurement & Production Management",
    path: "/services/production-management/",
    stage: "Produce",
    description: "Keep purchase requirements, supplier communication, production, and approvals aligned.",
  },
  {
    name: "Quality Control / Inspection",
    path: "/services/inspection/",
    stage: "Inspect",
    description: "Review goods, quantities, workmanship, and packaging before they leave China.",
  },
  {
    name: "Shipment Consolidation",
    path: "/services/consolidation/",
    stage: "Consolidate",
    description: "Bring goods from multiple suppliers into one organised outbound shipment.",
  },
  {
    name: "International Freight Forwarding",
    path: "/services/freight-forwarding/",
    stage: "Ship",
    description: "Coordinate the route, shipping documents, customs, and final delivery.",
  },
] as const;

export const brandProtectionServices = [
  { name: "China Trademark Support", path: "/services/china-trademark/" },
  { name: "NDA / NNN Agreement Coordination", path: "/services/nda-nnn-agreements/" },
] as const;

export const sourcingRequestPath = "/start-project/";
